import DataAPISerializer from 'rise-ui/serializers/apis/rise-api/data.js';

import { keyForAttribute } from 'rise-ui/utils/serializer/map.js';

@keyForAttribute({
  typeId:          'itemStructureId',
  type:            'dataStructure',
  title:           'itemTitle',
  description:     'itemDescription',
  publicationDate: 'publicationFirstPublicationDate',
})
export default class ItemSerializer extends DataAPISerializer {}
